export default function TabbedLinkListSkeleton() {
  return (
    <section className="container mx-auto w-full animate-pulse">
      <div className="container mx-auto px-4">
        <div className="mb-6 h-8 w-64 rounded bg-gray-200"></div>
        <div className="mb-4 flex space-x-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-10 w-24 rounded bg-gray-200"></div>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-20 rounded-lg bg-gray-200"></div>
          ))}
        </div>
      </div>
    </section>
  );
}
